import {
  Accordion,
  Button,
  Text,
  Title,
  Table,
  Select,
  Group,
} from "@mantine/core";
import React, { useState, useEffect } from "react";
import moment from "moment";
import { useServerApi } from "../hooks/userServerApi";
import { DatePicker } from "@mantine/dates";
import { useTranslation } from "react-i18next";
import _ from "lodash";
import RemoteSelect2 from "./remoteSelect2";
import { openFileUrl } from "../utils/openReport";

const ReportBankTransaction = ({}) => {
  const [loading, setLoading] = useState(false);
  const [dateType, setDateType] = useState("createdAt");

  const [api] = useServerApi();
  const { t } = useTranslation();
  const [fromDate, setFromDate] = useState();
  const [toDate, setToDate] = useState();

  const downloadReport = async () => {
    try {
      setLoading(true);

      // console.log(fromDate, toDate);

      const result = await api.BankTransaction.getReport({
        fromDate,
        toDate,
        dateType,
      });
      setLoading(false);
      console.log(result);
      if (result && result.url) {
        await openFileUrl(result.url);
      }
    } catch (error) {
      setLoading(false);
      // console.log(error);
    }
  };

  const DATA_REPORT_DATE_TYPE = [
    { label: "Created At", value: "createdAt" },
    { label: "Transaction Date", value: "date" },
    { label: "Match Date", value: "matchedDate" },
  ];

  return (
    <div>
      <Text size="xs" mb="xl">
        {t(
          "Please click the below button to download the outstanding document report."
        )}
      </Text>
      <Group mt="xs">
        <DatePicker
          title="From"
          size="xs"
          allowFreeInput
          placeholder="From"
          onChange={(d) => setFromDate(d)}
        />
        -
        <DatePicker
          title="To"
          size="xs"
          allowFreeInput
          placeholder="To"
          onChange={(d) => setToDate(d)}
        />
        <Select
          title="Date Type"
          size="xs"
          onChange={(d) => setDateType(d)}
          data={DATA_REPORT_DATE_TYPE}
        />
      </Group>

      <Button
        size="xs"
        mt="xl"
        onClick={() => downloadReport()}
        loading={loading}
      >
        {t("Download")}
      </Button>
      <></>
    </div>
  );
};

export default ReportBankTransaction;
